import { DocumentType } from 'types/DocumentType';
import { type FilterProperty } from 'types/FilterProperty';
import { nowOrServerTimestamp } from 'utils/FirestoreUtils';

import { FolderSchema } from './DocumentFolderTypes';

// interface CreativeSchemaProxy extends DocumentSchema {}; // TODO: To get around DocumentSchema not being ready when extending it. use: export class CreativeSchema implements CreativeSchemaProxy

export class CreativeSchema extends FolderSchema {
    type = DocumentType.CREATIVE;
    archived = false;
    dynamicProperties: any[] = [];
    filters: { name: string; filters: FilterProperty[] }[] = [];
    filterSets: any[] = [];
    author: string = '';
    name: string = '';
    notes: string = '';
    dateModified = nowOrServerTimestamp();
    tags: string[] = [];
}

export class CreativePublicSchema {
    type = DocumentType.PROJECT;
    name: string = '';
}
